import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d631f12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MenuContent CustomScrollbar" }
const _hoisted_2 = { class: "Top" }
const _hoisted_3 = { class: "Logo" }
const _hoisted_4 = { class: "Nav" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "BottomContent" }
const _hoisted_10 = { class: "Version" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" - ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!
  const _component_MenuToggle = _resolveComponent("MenuToggle")!
  const _component_LanguageSelect = _resolveComponent("LanguageSelect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DevMenu = _resolveComponent("DevMenu")!
  const _component_ProjectDetails = _resolveComponent("ProjectDetails")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["Menu", {'IsHidden': _ctx.menu.isHidden, 'IsMinimized': _ctx.menu.isMinimized, 'Fixed': _ctx.menu.isFixed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_InlineSVG, {
            src: require('@/assets/logo/milva-logo-white.svg')
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.mixWB('ONLINE_REPORT')), 1)
        ]),
        _createVNode(_component_MenuToggle),
        _createVNode(_component_LanguageSelect)
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: route?.name
          }, [
            route
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "Link",
                  to: { name: route.name }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InlineSVG, {
                      class: "ButtonIcon",
                      src: require(`@/assets/svg/${route.icon}.svg`)
                    }, null, 8, ["src"]),
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_ctx.mixWB(route.menuTranslation))
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _hoisted_6,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondaryRoutes, (route) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: route?.name
          }, [
            route
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "Link",
                  to: { name: route.name }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InlineSVG, {
                      class: "ButtonIcon",
                      src: require(`@/assets/svg/${route.icon}.svg`)
                    }, null, 8, ["src"]),
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_ctx.mixWB(route.menuTranslation))
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (_ctx.projectHasComments && _ctx.commentRoute)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "Link",
              to: { name: _ctx.commentRoute.name }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InlineSVG, {
                  class: "ButtonIcon",
                  src: require(`@/assets/svg/${_ctx.commentRoute.icon}.svg`)
                }, null, 8, ["src"]),
                _createElementVNode("span", {
                  textContent: _toDisplayString(_ctx.mixWB(_ctx.commentRoute.menuTranslation))
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_DevMenu),
        _createVNode(_component_ProjectDetails),
        _createElementVNode("button", {
          class: "MenuLineButton Feedback",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setShownDialog('feedback')))
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_InlineSVG, {
              class: "Icon",
              src: require('@/assets/svg/feedback.svg')
            }, null, 8, ["src"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.mixWB('GIVE_FEEDBACK')), 1)
          ])
        ]),
        _createElementVNode("button", {
          class: "MenuLineButton Help",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setShownDialog('pageGuide')))
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_InlineSVG, {
              class: "Icon",
              src: require('@/assets/svg/question.svg')
            }, null, 8, ["src"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.mixWB('GET_STARTED')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.versionText)
          }, null, 8, _hoisted_11),
          _hoisted_12,
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.renewCookieConsent()))
          }, _toDisplayString(_ctx.mixWB('ADAPT_COOKIES')), 1)
        ])
      ])
    ])
  ], 2))
}